import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, input } from '@angular/core';
import { BaseWidget } from '@/app/models/widget.model';
import { WidgetHeaderComponent } from '../../../shared/components/widget-header/widget-header.component';

@Component({
	selector: 'dr-flex-home-ui-placeholder-widget',
	standalone: true,
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [WidgetHeaderComponent],
	template: `
	<dr-flex-home-ui-widget-header [title]="widget().title"></dr-flex-home-ui-widget-header>
    <div class="placeholder-widget">
        <p>{{widget().__typename}} is not available yet.</p>
    </div>
	`,
	styleUrl: './placeholder-widget.component.scss'
})
export class PlaceholderWidgetComponent {
	 widget = input.required<BaseWidget>();
}
